export const formatHours = (hours: number | undefined): string => String(hours || 0).replace('.', ',')
